import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Modal, Tag, Popover } from 'antd'
import ChangeOnHoldState from '../actions/ChangeOnHoldState'
import MarkAsDone from '../actions/MarkAsDone'
import ToggleSafeZone from "../actions/ToggleSafeZone"
import LazyLoad from 'react-lazyload'
import { allowStore, allowType } from '../../../constants'
import Draggable from 'react-draggable'
import _ from "lodash"

class ItemImage extends Component {
    state = {
        visible: false,
        offSafeZone: false,
    }

    componentDidCatch(error, errorInfo) {
        console.log("ERROR__", error)
        console.log("ERROR__errorInfo", errorInfo)
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    _afterDoAction = (status) => {
        this.props.onChangeStatus(status)

        this._hideModal()
    }

    _toggleSafeZone = () => {
        this.setState({
            offSafeZone: !this.state.offSafeZone
        })
    }

    show_file_in = (preview, mockUp, isShowMockUp) => {
        const newImage = new Image()
        const { previewImage } = this.props
        if (!!previewImage) {
            newImage.src = previewImage
            const newWidth = newImage.width > newImage.height ? "100%" : "auto"
            const newHeight = newImage.width > newImage.height ? "auto" : "100%"
            return (
                <div className='position-relative'>
                    {isShowMockUp && <div className="MockupViewer position-absolute">
                        <img 
                            src={mockUp} 
                            alt='preview' 
                            className='d-block m-auto'
                            style={{objectFit: 'contain', height: 300}}
                        />
                    </div>}
                    <div className={`Preview position-relative PriviewFileIn ${isShowMockUp ? 'ml-3' : ''}`} style={{left: isShowMockUp ? 260 : 0}}>
                        <img src={preview} className='position-absolute' alt='preview' style={{ width: newWidth, height: newHeight, left: isShowMockUp ? 'unset' : 0 }} />
                    </div>
                </div>
            )
        }
    }

    render() {
        const { visible, offSafeZone } = this.state
        const { image, previewImage, status, orderId, type, cancelStatus, haveStatus, safezoneImage, tags, namespace, muckUpUrl, safezoneMovable, meta } = this.props
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
        const isShowMockUp = !!namespace && allowStore.includes(namespace) && !!type && allowType.includes(type)
        const isCMYK = _.get(meta, "infoData.generateOptions.imageOptions.cmyk", false)

        const showSafeZone = () => {
            if (!!safezoneImage) {
                const imagePreview = new Image()
                imagePreview.src = previewImage
                const imageSafezone = new Image()
                imageSafezone.src = safezoneImage
                const safezoneWidth = Math.round((1000 / imagePreview.width) * imageSafezone.width)
                const safezoneHeight = Math.round((1000 / imagePreview.width) * imageSafezone.height)

                return (
                    safezoneMovable ?
                    <Draggable
                        bounds="parent"
                    >
                        <div className="box" style={{width : safezoneWidth, height: safezoneHeight}}>
                            <img src={safezoneImage} alt="zoneZone" className="Safezone" style={{pointerEvents: 'none'}} />
                        </div>
                    </Draggable> : 
                    <img src={safezoneImage} alt="zoneZone" className="Safezone" />
                )
            }
        }

        return (
            <Popover
                placement="right"
                content={this.show_file_in(previewImage, muckUpUrl, isShowMockUp)}
                overlayClassName={`previewFixed ${visible ? 'd-none' : ''} ${isShowMockUp ? 'customMockup' : ''}`}
            >
                <td className='ItemImage'>
                    <LazyLoad>
                        {
                            previewImage ?
                                <div className={`Preview position-relative ${type}`}>
                                    <img src={previewImage} className='position-absolute' alt='preview' />
                                    {
                                        !offSafeZone && showSafeZone()
                                    }
                                    <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                        <span className='Icon cursor-pointer mr-2' onClick={this._showModal}><Icon type='eye' /></span>
                                        <a href={image} download className='Icon Download'><Icon type="download" /></a>
                                    </div>
                                    {
                                        isCMYK &&
                                        <div className='cmyk'>CMYK</div>
                                    }

                                    <Modal
                                        className='PrintedFileModal'
                                        style={{ "textAlign": "center" }}
                                        visible={visible}
                                        // closable={false}
                                        centered={true}
                                        footer={null}
                                        onCancel={this._hideModal}
                                    >
                                        {isShowMockUp && <div className="MockupViewer position-fixed">
                                            <img src={muckUpUrl} alt='preview' className='d-block m-auto'style={{objectFit: 'contain', height: 350}}/>
                                        </div>}
                                        <div className='Previewer' style={{ marginLeft: isShowMockUp ? 370 : 'auto' }}>
                                            <img src={previewImage} alt='preview' className='d-block m-auto' width={1000} style={{pointerEvents: 'none'}}/>
                                            {
                                                !offSafeZone && showSafeZone()
                                            }
                                        </div>
                                        <div className='bg-light d-flex align-items-center justify-content-between'>
                                            <div className="d-flex align-items-center">
                                                <div className={`OrderActions ${(haveStatus || cancelStatus) && 'disableAction'}`}>
                                                    <div className='Actions'>
                                                        <MarkAsDone orderId={orderId} onSuccess={this._afterDoAction} />
                                                        <ChangeOnHoldState
                                                            status={status}
                                                            orderId={orderId}
                                                            onChangeStatus={this._afterDoAction}
                                                        />
                                                    </div>
                                                </div>

                                                {
                                                    !!showSafeZone() && <div className='OrderActions'>
                                                        <div className='Actions'>
                                                            <ToggleSafeZone
                                                                offSafeZone={offSafeZone}
                                                                onToggleSafeZone={this._toggleSafeZone}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {
                                                isSpecialTag && <Tag color="#ff0000">Đặc biệt</Tag>
                                            }
                                        </div>
                                    </Modal>
                                </div>
                                : image &&
                                <a href={image} target='_blank' rel='noreferrer noopener' className='btn btn-sm text-primary'>
                                    <u>Download</u>
                                </a>
                        }
                    </LazyLoad>
                </td>
            </Popover>
        )
    }
}

ItemImage.propTypes = {
    image: PropTypes.string,
    previewImage: PropTypes.string,
    type: PropTypes.string.isRequired,
    size: PropTypes.string,
    safezoneImage: PropTypes.string
}

export default ItemImage
